import { GraphQLResult } from "@aws-amplify/api-graphql";

import {
  GetDocumentUrlQuery,
  GetDocumentUrlQueryVariables,
} from "@graphql/api";
import { api } from "@redux/api";
import { OperationName } from "@redux/utils/graphqlBaseOperation";

export const documentsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDocumentUrl: build.query<string, GetDocumentUrlQueryVariables>({
      query: (data) => {
        const operationName: OperationName = "getDocumentUrl";

        return {
          operationName,
          data,
        };
      },
      transformResponse: (response: GraphQLResult<GetDocumentUrlQuery>) =>
        response.data?.getDocumentUrl,
    }),
  }),
});

export const { useLazyGetDocumentUrlQuery } = documentsApi;
